import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { SiteLayoutComponent } from './layouts/site-layout/site-layout.component';
import { LoginComponent } from './login/login.component';
import { AuthorizationGuard as AuthGuard } from './authorization.guard';
import { SharednewsComponent } from './sharednews/sharednews.component';

const routes: Routes =[
  {
    path: '',
    component: LoginComponent
  }, 
  {
    path: 'admin',
    component: AdminLayoutComponent,
    data: { allowedRoles: [1,2,3] },
    canActivate: [AuthGuard],
    loadChildren: './layouts/admin-layout/admin-layout.module#AdminLayoutModule',
  },
  {
    path: 'site',
    component: SiteLayoutComponent,
    data: { allowedRoles: [1,2,3,4] },
    canActivate: [AuthGuard],
    loadChildren: './layouts/site-layout/site-layout.module#SiteLayoutModule',
  },
  {
    path: 'sharednews',
    component: SharednewsComponent,
  }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
